import React, { useState } from "react";

import { ChangeEventTimelineDiffRow } from "models";

import { Highlight } from "pages/admin/verifications/components/changeEvents/Highlight";
import { DIFF_PREVIEW } from "pages/admin/verifications/utils/changeEventTimeline";

type ChangeEventDiffTableProps = {
  diff: ChangeEventTimelineDiffRow[];
  truncated: boolean;
  query?: string;
  label?: string;
};

/** What moved between this snapshot and the previous one of the same entity. The API computes it; this only shows it. */
export const ChangeEventDiffTable = ({ diff, truncated, query, label = "changed" }: ChangeEventDiffTableProps) => {
  const [showAll, setShowAll] = useState(false);

  if (!diff?.length) return null;

  const rows = showAll ? diff : diff.slice(0, DIFF_PREVIEW);

  return (
    <div className="ce-block">
      <span className="ce-block-label">{truncated ? `${label} (first 30, capped)` : label}</span>
      <table className="ce-diff">
        <tbody>
          {rows.map((row) => (
            <tr key={row.key}>
              <th scope="row">
                <Highlight text={row.key} query={query} />
              </th>
              <td className="from">
                <Highlight text={row.from === null ? "—" : row.from} query={query} />
              </td>
              <td className="arrow">→</td>
              <td className="to">
                <Highlight text={row.to === null ? "—" : row.to} query={query} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {diff.length > DIFF_PREVIEW && !showAll && (
        <button type="button" className="ce-linkish" onClick={() => setShowAll(true)}>
          {`show all ${diff.length}`}
        </button>
      )}
    </div>
  );
};
